/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DrawWinnerRecord } from './DrawWinnerRecord';
import {
    DrawWinnerRecordFromJSON,
    DrawWinnerRecordFromJSONTyped,
    DrawWinnerRecordToJSON,
    DrawWinnerRecordToJSONTyped,
} from './DrawWinnerRecord';
import type { RejectedWinner } from './RejectedWinner';
import {
    RejectedWinnerFromJSON,
    RejectedWinnerFromJSONTyped,
    RejectedWinnerToJSON,
    RejectedWinnerToJSONTyped,
} from './RejectedWinner';
import type { RewardSelection } from './RewardSelection';
import {
    RewardSelectionFromJSON,
    RewardSelectionFromJSONTyped,
    RewardSelectionToJSON,
    RewardSelectionToJSONTyped,
} from './RewardSelection';

/**
 * Audit log for challenge prize drawings - provides transparency and legal compliance
 * @export
 * @interface ChallengeDrawLog
 */
export interface ChallengeDrawLog {
    /**
     * 
     * @type {string}
     * @memberof ChallengeDrawLog
     */
    id?: string;
    /**
     * 
     * @type {number}
     * @memberof ChallengeDrawLog
     */
    createdAt?: number;
    /**
     * 
     * @type {number}
     * @memberof ChallengeDrawLog
     */
    updatedAt?: number;
    /**
     * The challenge this draw belongs to
     * @type {string}
     * @memberof ChallengeDrawLog
     */
    challengeId?: string;
    /**
     * 
     * @type {string}
     * @memberof ChallengeDrawLog
     */
    challengeName?: string;
    /**
     * 
     * @type {string}
     * @memberof ChallengeDrawLog
     */
    drawType?: ChallengeDrawLogDrawTypeEnum;
    /**
     * For SEGMENT draws, which segment (0-indexed)
     * @type {number}
     * @memberof ChallengeDrawLog
     */
    segmentIndex?: number;
    /**
     * For CHALLENGE_DRAW draws, the sub-doc _id in Challenge.draws[] that this log corresponds to. Used by distributeDrawLogPrizes to stamp draws.$.rewardsDistributedAt.
     * @type {string}
     * @memberof ChallengeDrawLog
     */
    challengeDrawId?: string;
    /**
     * Unix timestamp when draw occurred
     * @type {number}
     * @memberof ChallengeDrawLog
     */
    drawTimestamp?: number;
    /**
     * Total raffle entries (with duplicates)
     * @type {number}
     * @memberof ChallengeDrawLog
     */
    totalEntriesInPool?: number;
    /**
     * Number of unique users in the draw
     * @type {number}
     * @memberof ChallengeDrawLog
     */
    uniqueParticipants?: number;
    /**
     * 
     * @type {number}
     * @memberof ChallengeDrawLog
     */
    totalPrizesAwarded?: number;
    /**
     * 
     * @type {RewardSelection}
     * @memberof ChallengeDrawLog
     */
    rewardSelectionType?: RewardSelection;
    /**
     * 
     * @type {Array<DrawWinnerRecord>}
     * @memberof ChallengeDrawLog
     */
    winners?: Array<DrawWinnerRecord>;
    /**
     * List of manually redrawn users that are rejected from winning.
     * @type {Array<RejectedWinner>}
     * @memberof ChallengeDrawLog
     */
    rejectedWinners?: Array<RejectedWinner>;
    /**
     * If rewards were distributed based on this log
     * @type {boolean}
     * @memberof ChallengeDrawLog
     */
    hasDistributedRewards?: boolean;
    /**
     * If this log was generated by a dry run
     * @type {boolean}
     * @memberof ChallengeDrawLog
     */
    dryRun?: boolean;
    /**
     * Admin user ID if manually triggered
     * @type {string}
     * @memberof ChallengeDrawLog
     */
    adminTriggeredBy?: string;
    /**
     * Any additional notes about the draw
     * @type {string}
     * @memberof ChallengeDrawLog
     */
    notes?: string;
    /**
     * Full list of participants with their amount of draw entries
     * @type {{ [key: string]: number; }}
     * @memberof ChallengeDrawLog
     */
    entrants?: { [key: string]: number; };
}


/**
 * @export
 */
export const ChallengeDrawLogDrawTypeEnum = {
    SEGMENT: 'SEGMENT',
    GRAND_PRIZE: 'GRAND_PRIZE',
    CHALLENGE_DRAW: 'CHALLENGE_DRAW'
} as const;
export type ChallengeDrawLogDrawTypeEnum = typeof ChallengeDrawLogDrawTypeEnum[keyof typeof ChallengeDrawLogDrawTypeEnum];


/**
 * Check if a given object implements the ChallengeDrawLog interface.
 */
export function instanceOfChallengeDrawLog(value: object): value is ChallengeDrawLog {
    return true;
}

export function ChallengeDrawLogFromJSON(json: any): ChallengeDrawLog {
    return ChallengeDrawLogFromJSONTyped(json, false);
}

export function ChallengeDrawLogFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChallengeDrawLog {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'createdAt': json['createdAt'] == null ? undefined : json['createdAt'],
        'updatedAt': json['updatedAt'] == null ? undefined : json['updatedAt'],
        'challengeId': json['challengeId'] == null ? undefined : json['challengeId'],
        'challengeName': json['challengeName'] == null ? undefined : json['challengeName'],
        'drawType': json['drawType'] == null ? undefined : json['drawType'],
        'segmentIndex': json['segmentIndex'] == null ? undefined : json['segmentIndex'],
        'challengeDrawId': json['challengeDrawId'] == null ? undefined : json['challengeDrawId'],
        'drawTimestamp': json['drawTimestamp'] == null ? undefined : json['drawTimestamp'],
        'totalEntriesInPool': json['totalEntriesInPool'] == null ? undefined : json['totalEntriesInPool'],
        'uniqueParticipants': json['uniqueParticipants'] == null ? undefined : json['uniqueParticipants'],
        'totalPrizesAwarded': json['totalPrizesAwarded'] == null ? undefined : json['totalPrizesAwarded'],
        'rewardSelectionType': json['rewardSelectionType'] == null ? undefined : RewardSelectionFromJSON(json['rewardSelectionType']),
        'winners': json['winners'] == null ? undefined : ((json['winners'] as Array<any>).map(DrawWinnerRecordFromJSON)),
        'rejectedWinners': json['rejectedWinners'] == null ? undefined : ((json['rejectedWinners'] as Array<any>).map(RejectedWinnerFromJSON)),
        'hasDistributedRewards': json['hasDistributedRewards'] == null ? undefined : json['hasDistributedRewards'],
        'dryRun': json['dryRun'] == null ? undefined : json['dryRun'],
        'adminTriggeredBy': json['adminTriggeredBy'] == null ? undefined : json['adminTriggeredBy'],
        'notes': json['notes'] == null ? undefined : json['notes'],
        'entrants': json['entrants'] == null ? undefined : json['entrants'],
    };
}

export function ChallengeDrawLogToJSON(json: any): ChallengeDrawLog {
    return ChallengeDrawLogToJSONTyped(json, false);
}

export function ChallengeDrawLogToJSONTyped(value?: ChallengeDrawLog | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'createdAt': value['createdAt'],
        'updatedAt': value['updatedAt'],
        'challengeId': value['challengeId'],
        'challengeName': value['challengeName'],
        'drawType': value['drawType'],
        'segmentIndex': value['segmentIndex'],
        'challengeDrawId': value['challengeDrawId'],
        'drawTimestamp': value['drawTimestamp'],
        'totalEntriesInPool': value['totalEntriesInPool'],
        'uniqueParticipants': value['uniqueParticipants'],
        'totalPrizesAwarded': value['totalPrizesAwarded'],
        'rewardSelectionType': RewardSelectionToJSON(value['rewardSelectionType']),
        'winners': value['winners'] == null ? undefined : ((value['winners'] as Array<any>).map(DrawWinnerRecordToJSON)),
        'rejectedWinners': value['rejectedWinners'] == null ? undefined : ((value['rejectedWinners'] as Array<any>).map(RejectedWinnerToJSON)),
        'hasDistributedRewards': value['hasDistributedRewards'],
        'dryRun': value['dryRun'],
        'adminTriggeredBy': value['adminTriggeredBy'],
        'notes': value['notes'],
        'entrants': value['entrants'],
    };
}

